export default __webpack_public_path__ + "static/media/5.15c13f75.png";